/*
 * @Author: changcheng
 * @LastEditTime: 2023-04-20 10:55:30
 */
import React, { useEffect, FC } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import { Avatar, message } from "antd";
import "./index.less";
import axios from "@/axios/axios";
const PersonalCenter: FC<any> = ({ history, storeData, dispatchAction }) => {
  const { userInfo } = storeData;
  const logOut = async () => {
    const { code, msg }: any = await axios.post("/shop/front/exit");
    if (code == 0) {
      dispatchAction({ type: "SET_USER_INFO", payload: { userInfo: null } });
    } else {
      message.error(msg);
    }
  };
  return (
    <div className={"personal-center-module"}>
      <div className={"content"}>
        <div className={"img-box"}>
          <Avatar size={99} src={userInfo.avatar} />
        </div>
        <div className={"username"}>{userInfo.name}</div>
        <p>
          <Link to="/updateUserInfo">完善信息</Link>
        </p>
        {/*<div>*/}
        {/*    <Button block>*/}
        {/*        个人学习中心*/}
        {/*    </Button>*/}
        {/*</div>*/}
      </div>
      <div className={"logout"}>
        <a
          onClick={() => {
            logOut();
          }}
        >
          退出登录
        </a>
        <Link to="/index/personCenter/contactUs">用户帮助</Link>
      </div>
    </div>
  );
};

export default connect(
  (state) => state,
  (dispatch) => {
    return {
      dispatchAction: (param: any) => {
        dispatch({ ...param });
      },
    };
  }
)(withRouter(PersonalCenter));
